import "../sass/main.scss";

import $ from "jquery";
import PressArchive from "./pages/press-archive";
import People from "./pages/people";
import Contact from "./pages/contact";
import Story from "./pages/story";
import Search from "./components/search";
import Menu from "./components/menu";
import Modal from "./components/modal";
import Chapters from "./components/chapters";
import Reveal from "./components/reveal";
import PeopleGallery from "./components/people-gallery";
import Share from "./components/share";
import Chart from "./components/chart";
import SlideToggle from "./components/slide-toggle";
import Timeline from "./components/timeline";
import TopicSpotlight from "./components/topic-spotlight";
import VideoWrapper from "./helpers/VideoWrapper";
// import LazySizes from 'lazysizes';
import LazyLoad from "vanilla-lazyload";
import Events from "./components/events";
import YoutubePlaceholder from "./components/youtube-placeholder";
import "./components/web2Lead";

import { greenhouse } from "./components/greenhouse";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
import Swiper from "swiper/bundle";

import "swiper/css/bundle";

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.Swiper = Swiper;

document.addEventListener("alpine:init", () => {
    Alpine.data("greenhouse", greenhouse);
});

$(document).ready(() => {
    var lazyload = new LazyLoad({
        elements_selector: ".lazyload"
    });
    window.lazyload = lazyload;

    PressArchive.init();
    People.init();
    Contact.init();
    Story.init();
    Search.init();
    Menu.init();
    Modal.init();
    Chapters.init();
    Reveal.init();
    Events.init();
    Share.init();
    Chart.init();
    VideoWrapper.init();
    SlideToggle.init();
    Timeline.init();
    TopicSpotlight.init();
    YoutubePlaceholder.init();

    // Make sure external links open in a new tab
    // Select anchor tags that start with 'http' and are not internal links
    // And set target="_blank" and rel="noopener" so they open in a new tab
    const internalLink = `a[href^='${$(location).attr("protocol")}//${$(
        location
    ).attr("host")}']`;

    $('a[href^="http"]')
        .not(internalLink)
        .attr("target", "_blank")
        .attr("rel", "noopener");

    // Companies
    if ($(".companies__grid").length > 0) {
        import("./pages/companies").then(({ default: Companies }) => {
            this.companies = new Companies();
        });
    }

    $(".nav__container").hover(
        function() {
            var height = this.querySelector(".nav__dropdown--inner")
                .offsetHeight;
            var el = this.querySelector(".nav__dropdown");
            this.classList.add("nav__container--active");
            el.classList.add("nav__dropdown--active");
            el.style.maxHeight = height.toString() + "px";
        },
        function() {
            var height = this.querySelector(".nav__dropdown--inner")
                .offsetHeight;
            var el = this.querySelector(".nav__dropdown");
            this.classList.remove("nav__container--active");
            el.classList.remove("nav__dropdown--active");
            el.style.maxHeight = "0px";
        }
    );
    $(".menu__container").on("click", function() {
        var height = this.querySelector(".menu__dropdown--inner").offsetHeight;
        var el = this.querySelector(".menu__dropdown");
        if (el.classList.contains("menu__dropdown--active")) {
            this.classList.remove("menu__container--active");
            el.classList.remove("menu__dropdown--active");
            el.style.maxHeight = "0px";
        } else {
            this.classList.add("menu__container--active");
            el.classList.add("menu__dropdown--active");
            el.style.maxHeight = height.toString() + "px";
        }
    });

    console.log("Load");

    window.addEventListener("CookiebotOnDecline", function() {
        console.log("decline");
        if (Cookiebot.changed) {
            document.location.reload();
        }
    });

    // Refresh page when user accepts cookies via Cookiebot
    window.addEventListener("CookiebotOnAccept", function() {
        console.log("accept");
        if (Cookiebot.changed) {
            document.location.reload();
        }
    });
});

window.onload = function() {
    if ($(".js-people-gallery").length > 0) {
        PeopleGallery.init();
    }
};

import {
    ShaderMount,
    ditheringFragmentShader,
    getShaderColorFromString
} from "@paper-design/shaders";

const ditheringContainer = document.getElementById("dither-shader-1");
if (ditheringContainer) {
    const shapeMap = {
        simplex: 0,
        warp: 1,
        dots: 2,
        wave: 3,
        ripple: 4,
        swirl: 5,
        sphere: 6
    };
    const typeMap = { random: 0, "2x2": 1, "4x4": 2, "8x8": 3 };

    new ShaderMount(
        ditheringContainer,
        ditheringFragmentShader,
        {
            u_colorBack: getShaderColorFromString("#ffffff"),
            u_colorFront: getShaderColorFromString("#000000"),
            u_shape: shapeMap["simplex"],
            u_type: typeMap["8x8"],
            u_pxSize: 3.8,
            u_scale: 2.25,
            u_offsetX: Math.random() * 2 - 1,
            u_offsetY: Math.random() * 2 - 1
        },
        undefined,
        0.3 // speed
    );
}
